import { createRouter, createWebHistory } from 'vue-router';

// Lazy load components
const UserView = () => import('../components/UserView/UserBody.vue');
const UserInfo = () => import('../components/UserView/UserInfo.vue');
const UserCreate = () => import('../components/UserView/UserCreate.vue');
const SiteView = () => import('../components/SiteView/SiteBody.vue');
const AttributeView = () => import('../components/AttributeView/AttributeBody.vue');
const LoginView = () => import('../components/LoginView/LoginBody.vue');
const DashboardView = () => import('@/components/DashboardView/DashboardBody.vue');
const TestingView = () => import('@/components/TestView/TestBody.vue');
const HistoryView = () => import('@/components/HistoryView/HistoryBody.vue');
const CreditView = () => import('@/components/CreditView/CreditBody.vue');
const ModelView = () => import('@/components/ModelView/ModelBody.vue');
const ServerView = () => import('@/components/ServerView/ServerBody.vue');
const FilenamePresetView = () => import('@/components/FilenamePresetView/FilenamePresetBody.vue');

const routes = [
  {
    path: '/', // Default path (root)
    redirect: '/login', // Redirect to login
  },
  {
    path: '/user',
    name: 'user',
    component: UserView,
  },
  {
    path: '/user/:id',
    name: 'userinfo',
    component: UserInfo,
  },
  {
    path: '/user/create',
    name: 'usercreate',
    component: UserCreate,
  },
  {
    path: '/site',
    name: 'siteView',
    component: SiteView,
  },
  {
    path: '/site/:id',
    name: 'site',
    component: SiteView,
  },
  {
    path: '/attribute',
    name: 'attribute',
    component: AttributeView,
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: DashboardView,
  },
    {
    path: '/credit',
    name: 'credit',
    component: CreditView,
  },
    {
    path: '/credit/:id',
    name: 'creditInfo',
    component: CreditView,
  },
  {
    path: '/testing',
    name: 'testing',
    component: TestingView,
  },
  {
    path: '/log',
    name: 'log',
    component: HistoryView,
  },
  {
    path: '/models',
    name: 'models',
    component: ModelView,
    meta: { requiresPermission: ['MODEL_READ', 'MODEL_UPLOAD', 'data_scientist', 'scientist'] },
  },
  {
    path: '/server',
    name: 'server',
    component: ServerView,
    meta: { requiresPermission: ['admin', 'trueeye_admin', 'trueeye_staff', 'MODEL_READ', 'data_scientist', 'scientist'] },
  },
  {
    path: '/filename-presets',
    name: 'filenamePresets',
    component: FilenamePresetView,
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

import { usePermissions } from '../composables/usePermissions';

router.beforeEach((to, from, next) => {
  const isAuthenticated = !!sessionStorage.getItem('token');
  
  if (to.name !== 'login' && !isAuthenticated) {
    next({ name: 'login' });
    return;
  }

  if (to.name === 'login' && isAuthenticated) {
    next({ name: 'dashboard' }); // Redirect authenticated users to dashboard
    return;
  }

  // Permission Guarding
  if (isAuthenticated && to.meta && to.meta.requiresPermission) {
    const { initPermissions, hasAnyPermission } = usePermissions();
    // Ensure permissions are loaded from current token
    initPermissions();

    const requiredPerms = Array.isArray(to.meta.requiresPermission) 
      ? to.meta.requiresPermission 
      : [to.meta.requiresPermission];

    if (!hasAnyPermission(requiredPerms)) {
      console.warn(`Access Denied: Route '${to.name}' requires permissions:`, requiredPerms);
      // Redirect to a default route like dashboard or a dedicated 403 page
      next({ name: 'dashboard' }); // In a real app, maybe next({ name: 'unauthorized' })
      return;
    }
  }

  next();
});

export default router;
